import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { PromoCard, PromoCardProps } from './PromoCard'

export const PromoCardRegistration = createRegisterableComponent(
    'promo-card',
    (props: Omit<PromoCardProps, 'onEvent'>, { onEvent }) => (
        <PromoCard {...props} onEvent={onEvent} />
    ),
)
